import { render } from "./AddWijkrondeView.vue?vue&type=template&id=1675dc78&scoped=true"
import script from "./AddWijkrondeView.vue?vue&type=script&lang=js"
export * from "./AddWijkrondeView.vue?vue&type=script&lang=js"

import "./AddWijkrondeView.vue?vue&type=style&index=0&id=1675dc78&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1675dc78"]])

export default __exports__